export default {
	notification_health: 'Estado de las notificaciones',
	notification_health_summary: 'Resumen',
	notification_health_loading: 'Comprobando el estado de las notificaciones...',
	notification_health_refresh: 'Actualizar',
	notification_health_fix: 'Qué hacer',
	notification_health_unavailable: 'No se pudo cargar el estado de las notificaciones',
	notification_health_healthy: 'Correcto',
	notification_health_blocked: 'Bloqueado',
	notification_health_degraded: 'Requiere atención',
	notification_health_no_app_user: 'Sin inicio de sesión en la app',
	notification_health_unknown: 'Desconocido',
	notification_health_app_version: 'Versión de la app',
	notification_health_last_delivery: 'Última entrega',
	notification_health_time_just_now: 'ahora mismo',
	notification_health_time_minutes: 'hace {count} minuto(s)',
	notification_health_time_hours: 'hace {count} hora(s)',
	notification_health_time_days: 'hace {count} día(s)',
	notification_health_time_unknown: 'desconocido',
	notification_health_summary_healthy: 'Las notificaciones deberían funcionar',
	notification_health_summary_no_app_user: 'El personal de limpieza no ha iniciado sesión en la app móvil',
	notification_health_summary_blocked_no_token: 'Falta el token push — el personal debe abrir la app e iniciar sesión',
	notification_health_summary_blocked_off: 'Las notificaciones están desactivadas en la app',
	notification_health_check_portal_contact_label: 'Existe contacto en el portal',
	notification_health_check_portal_active_label: 'Contacto activo',
	notification_health_check_portal_rooms_label: 'Salas asignadas',
	notification_health_check_portal_shifts_label: 'Turnos asignados',
	notification_health_check_app_user_label: 'Sesión iniciada en la app móvil',
	notification_health_check_push_token_label: 'Token push registrado',
	notification_health_check_notification_mode_label: 'Modo de notificación',
	notification_health_check_time_schedule_label: 'Dentro de la ventana de notificaciones',
	notification_health_check_ios_geo_filter_label: 'Filtro de ubicación iOS',
	notification_health_check_recent_push_attempt_label: 'Intento de push reciente (48 h)',
	notification_health_check_last_push_ignored_label: 'La última señal no se envió',
	notification_health_check_recent_push_delivered_label: 'Push entregado recientemente (48 h)',
	notification_health_detail_portal_contact_found: 'Encontrado en el portal',
	notification_health_detail_portal_contact_missing: 'No se encontró registro de contacto',
	notification_health_detail_portal_active_active: 'Activo',
	notification_health_detail_portal_active_inactive: 'Inactivo',
	notification_health_detail_portal_rooms_assigned: '{count} sala(s)',
	notification_health_detail_portal_rooms_none: 'No hay salas asignadas',
	notification_health_detail_portal_shifts_assigned: '{count} turno(s)',
	notification_health_detail_portal_shifts_none: 'No hay turnos asignados',
	notification_health_detail_app_user_logged_in: 'Versión de la app {version}, última sincronización {lastSync}',
	notification_health_detail_app_user_never: 'Nunca ha iniciado sesión',
	notification_health_detail_push_token_present: 'Token FCM presente',
	notification_health_detail_push_token_empty: 'El token está vacío',
	notification_health_detail_notification_mode: '{mode}',
	notification_health_detail_time_schedule_inside: 'La hora actual está dentro del horario',
	notification_health_detail_time_schedule_outside: 'La hora actual está fuera del horario configurado',
	notification_health_detail_ios_geo_filter: '{filter}',
	notification_health_detail_recent_push_attempt_at: '{time}',
	notification_health_detail_recent_push_attempt_none: 'No hay intentos de push en las últimas 48 horas',
	notification_health_detail_last_push_ignored: 'La última solicitud de push fue ignorada (servik no configurado para el área de trabajo)',
	notification_health_detail_recent_push_delivered_at: '{time}',
	notification_health_detail_recent_push_delivered_none: 'No hay entregas exitosas en las últimas 48 horas',
	notification_health_fix_portal_contact: 'Crear este personal de limpieza en el panel de Usuarios',
	notification_health_fix_portal_active: 'Activar el interruptor Activo para este personal',
	notification_health_fix_portal_rooms: 'Asignar al menos una sala a este personal',
	notification_health_fix_portal_shifts: 'Asignar al menos un turno',
	notification_health_fix_app_user: 'El personal debe instalar la app e iniciar sesión con este número de teléfono',
	notification_health_fix_push_token: 'Pida al personal que abra la app, permita notificaciones en Ajustes de iOS e inicie sesión de nuevo',
	notification_health_fix_notification_mode: 'Cambiar el modo de notificación de Desactivado a Siempre en la app',
	notification_health_fix_time_schedule: 'Espere hasta la ventana programada o cambie el modo a Siempre',
	notification_health_fix_ios_geo_filter: 'El personal está fuera de su zona de notificación — pídale que abra la app en el sitio',
	notification_health_fix_last_push_ignored: 'Compruebe la configuración del servik del área de trabajo para la sala que activó la señal',
	notification_health_fix_recent_push_delivered_filters: 'Compruebe los filtros de notificación o la configuración del dispositivo',
	notification_health_fix_recent_push_delivered_token: 'Registre primero el token push',
	notification_health_mode_on: 'Siempre',
	notification_health_mode_off: 'Desactivado',
	notification_health_mode_time: 'Por horario',
	notification_health_mode_location: 'Por ubicación',
	notification_health_filter_on: 'Activado',
	notification_health_filter_off: 'Desactivado',
};
